import { EQUIPMENT } from "./equipmentLayer";
import { BODY } from "./baseLayer";

/** Layer stack order: higher number draws on top. Entries below are sorted high → low. */
export const zIndex = {
  [EQUIPMENT.OFFHAND.ONE_HANDED.SHIELD.UNDER]: 505,
  [EQUIPMENT.HELM]: 500,
  [BODY.HAIR.OVER]: 480,
  /** Body/base — not shared with equipment layer ids. Gloves intentionally share body arm z values. */
  [BODY.HEAD.BASE]: 475,
  [EQUIPMENT.CHEST.MAINHAND.TWO_HANDED]: 430,
  [BODY.OFFHAND.TWO_HANDED.OVER]: 429,
  [EQUIPMENT.GLOVES.OFFHAND.TWO_HANDED.OVER]: 429, // = BODY.OFFHAND.TWO_HANDED.OVER
  [BODY.MAINHAND.TWO_HANDED.OVER]: 410,
  [EQUIPMENT.GLOVES.MAINHAND.TWO_HANDED.OVER]: 410, // = BODY.MAINHAND.TWO_HANDED.OVER
  [BODY.OFFHAND.TWO_HANDED.UNDER]: 370, // flipped with OVER so OVER draws above UNDER
  [EQUIPMENT.GLOVES.OFFHAND.TWO_HANDED.UNDER]: 370, // = BODY.OFFHAND.TWO_HANDED.UNDER
  [EQUIPMENT.CHEST.OFFHAND.TWO_HANDED]: 350,
  [BODY.MAINHAND.TWO_HANDED.UNDER]: 349,
  [EQUIPMENT.GLOVES.MAINHAND.TWO_HANDED.UNDER]: 349, // = BODY.MAINHAND.TWO_HANDED.UNDER
  [EQUIPMENT.MAINHAND.TWO_HANDED.UNDER]: 340,
  [EQUIPMENT.CHEST.MAINHAND.CROSSBOW_TWO_HANDED]: 330,
  [BODY.OFFHAND.TWO_HANDED_CROSSBOW.UNDER]: 329,
  [EQUIPMENT.CHEST.OFFHAND.CROSSBOW_TWO_HANDED]: 329,
  [EQUIPMENT.GLOVES.OFFHAND.TWO_HANDED_CROSSBOW.UNDER]: 329, // = BODY.OFFHAND.TWO_HANDED_CROSSBOW.UNDER
  /** No BODY.OFFHAND.TWO_HANDED_CROSSBOW.OVER — might not need this; same z as UNDER. */
  [EQUIPMENT.GLOVES.OFFHAND.TWO_HANDED_CROSSBOW.OVER]: 329,
  [BODY.MAINHAND.TWO_HANDED_CROSSBOW.OVER]: 320,
  [EQUIPMENT.GLOVES.MAINHAND.TWO_HANDED_CROSSBOW.OVER]: 320, // = BODY.MAINHAND.TWO_HANDED_CROSSBOW.OVER
  [EQUIPMENT.MAINHAND.TWO_HANDED.OVER]: 310,
  [EQUIPMENT.OFFHAND.ONE_HANDED.CROSSBOW.UNDER]: 290,
  [EQUIPMENT.CHEST.MAINHAND.CROSSBOW_ONE_HANDED]: 285,
  [BODY.OFFHAND.ONE_HANDED_CROSSBOW.UNDER]: 284,
  [EQUIPMENT.CHEST.OFFHAND.CROSSBOW_ONE_HANDED]: 284,
  [EQUIPMENT.GLOVES.OFFHAND.CROSSBOW.UNDER]: 284, // = BODY.OFFHAND.ONE_HANDED_CROSSBOW.UNDER
  /** No BODY.OFFHAND.ONE_HANDED_CROSSBOW.OVER — might not need this; same z as UNDER. */
  [EQUIPMENT.GLOVES.OFFHAND.CROSSBOW.OVER]: 284,
  [EQUIPMENT.OFFHAND.ONE_HANDED.CROSSBOW.OVER]: 275,
  [EQUIPMENT.MAINHAND.ONE_HANDED.CROSSBOW.OVER]: 274,
  [EQUIPMENT.MAINHAND.ONE_HANDED.CROSSBOW.UNDER]: 270,
  [EQUIPMENT.CHEST.MAINHAND.ONE_HANDED]: 265,
  [BODY.MAINHAND.ONE_HANDED_THROWING.UNDER]: 264,
  [BODY.OFFHAND.ONE_HANDED.OVER]: 264,
  [EQUIPMENT.CHEST.MAINHAND.THROWING]: 264,
  /** Same band as {@link BODY.OFFHAND.ONE_HANDED.UNDER} — off-hand chest must paint over torso/arm under on that side. */
  [EQUIPMENT.CHEST.OFFHAND.ONE_HANDED]: 264,
  [EQUIPMENT.GLOVES.MAINHAND.THROWING.UNDER]: 264, // = BODY.MAINHAND.ONE_HANDED_THROWING.UNDER
  /** No BODY.MAINHAND.ONE_HANDED_THROWING.OVER — might not need this; same z as UNDER. */
  [EQUIPMENT.GLOVES.MAINHAND.THROWING.OVER]: 264,
  [EQUIPMENT.GLOVES.OFFHAND.ONE_HANDED.OVER]: 264, // = BODY.OFFHAND.ONE_HANDED.OVER
  [BODY.OFFHAND.ONE_HANDED.UNDER]: 255, // flipped with OVER so OVER draws above UNDER
  [EQUIPMENT.GLOVES.OFFHAND.ONE_HANDED.UNDER]: 255, // = BODY.OFFHAND.ONE_HANDED.UNDER
  [EQUIPMENT.CHEST.OFFHAND.THROWING]: 230,
  [BODY.OFFHAND.ONE_HANDED_THROWING.UNDER]: 224,
  [EQUIPMENT.GLOVES.OFFHAND.THROWING.UNDER]: 224, // = BODY.OFFHAND.ONE_HANDED_THROWING.UNDER
  /** No BODY.OFFHAND.ONE_HANDED_THROWING.OVER — might not need this; same z as UNDER. */
  [EQUIPMENT.GLOVES.OFFHAND.THROWING.OVER]: 224,
  [EQUIPMENT.CHEST.BODY.UNTUCKED]: 223,
  [EQUIPMENT.BOOTS.UNTUCKED]: 220,
  [EQUIPMENT.PANTS.UNTUCKED]: 210,
  [BODY.UNDERWEAR.BOTTOM]: 209,
  /** Under-layer for pants (e.g. leggings); between chest and `PANTSOVER`. */
  [EQUIPMENT.PANTS.TUCKED]: 205,
  [EQUIPMENT.CHEST.BODY.TUCKED]: 200,
  [EQUIPMENT.BOOTS.TUCKED]: 200,
  [BODY.BODY.BASE]: 199,
  [BODY.MAINHAND.TWO_HANDED_CROSSBOW.UNDER]: 89,
  [EQUIPMENT.GLOVES.MAINHAND.TWO_HANDED_CROSSBOW.UNDER]: 89, // = BODY.MAINHAND.TWO_HANDED_CROSSBOW.UNDER
  [BODY.MAINHAND.ONE_HANDED.OVER]: 70,
  [EQUIPMENT.GLOVES.MAINHAND.ONE_HANDED.OVER]: 70, // = BODY.MAINHAND.ONE_HANDED.OVER
  [EQUIPMENT.MAINHAND.ONE_HANDED.DEFAULT.UNDER]: 60,
  [BODY.MAINHAND.ONE_HANDED.UNDER]: 49,
  [EQUIPMENT.GLOVES.MAINHAND.ONE_HANDED.UNDER]: 49, // = BODY.MAINHAND.ONE_HANDED.UNDER
  [BODY.MAINHAND.ONE_HANDED_CROSSBOW.UNDER]: 29,
  [EQUIPMENT.GLOVES.MAINHAND.CROSSBOW.UNDER]: 29, // = BODY.MAINHAND.ONE_HANDED_CROSSBOW.UNDER
  /** No BODY.MAINHAND.ONE_HANDED_CROSSBOW.OVER — might not need this; same z as UNDER. */
  [EQUIPMENT.GLOVES.MAINHAND.CROSSBOW.OVER]: 29
} as const;

/** Semantic layer id (matches keys of `zIndex`). Equipment image rows reference this; numbers resolve at build time. */
export type ZIndexLayerKey = keyof typeof zIndex;

export function zIndexValue(layer: ZIndexLayerKey): number {
  return zIndex[layer];
}
